import * as React from 'react';

import { ListPerformanceProps } from '../../components/list/performance';
import ListProduction from '../../components/list/production';

const ListPerformanceView: React.StatelessComponent<ListPerformanceProps> = props => {

    return (
        <li className="ace-production-row">
            <p className="ace-production-row-datetime">
                <span className="h2-secondary">{props.performance.performanceDateDayString}</span>
                <span className="h2-secondary">{props.performance.performanceTimeString}</span>
            </p>
            {
                props.showReserveButton ?
                    <p>
                        <button className={props.performanceInCart ? 'btn-outline' : 'btn-primary'} disabled={!props.performanceInCart && !props.allowReserve} onClick={() => {
                            if (props.performanceInCart) {
                                props.removeFromCart(props.performance.performanceId);
                            } else {
                                props.selectPerformance(props.performance, props.useUnSeatedReservation);
                            }
                        }}>
                            {props.performanceInCart ? props.text.removeButtonText : props.text.addToCartButtonText}
                        </button>
                    </p>
                    : null
            }

        </li>
    );
}

export default ListPerformanceView;